import { type Category } from '@services';

export const recursivelyFindCategory = (categories: Category[], id: string): Category | null => {
  for (const category of categories) {
    if (category.id === id) return category;

    if (category.children?.length) {
      const deepCategory = recursivelyFindCategory(category.children, id);
      if (deepCategory) {
        return deepCategory;
      }
    }
  }

  return null;
};
export const recursivelyFindCategoryByKey = (categories: Category[], key: string): Category | null => {
  for (const category of categories) {
    if (category.key === key) return category;

    if (category.children?.length) {
      const deepCategory = recursivelyFindCategoryByKey(category.children, key);
      if (deepCategory) {
        return deepCategory;
      }
    }
  }

  return null;
};
